import AppRouteConfig from '@/utils/helper/AppRouteConfig'

function appendParams(url, key, value, isFirst) {
  return isFirst ? (url + '?' + key + '=' + value) : (url + '&' + key + '=' + value)
}

export default class RouterSwitchHelper {
  /**
   * 跳转产品详情
   * @param vueInstance
   * @param proId
   * @param proType
   * @param proSource
   * @param query
   */
  static toProductDetails(domainUrl, proId, proType, proSource, query) {
    let params = {
      proId: proId,
      type: proType,
      conn: proSource
    }
    let detailsPath = AppRouteConfig.getDetailsPath(proType)
    let skipPath = RouterSwitchHelper.getTargetUrl(domainUrl + detailsPath, { ...params, ...query })
    window.open(skipPath)
  }

  static getTargetUrl(baseUrl, params) {
    let hasStartFlag = baseUrl.indexOf('?') !== -1
    if (params instanceof Object) {
      let requestUtl = baseUrl
      for (let key in params) {
        if (params[key] !== undefined) {
          if (!hasStartFlag) {
            hasStartFlag = true
            requestUtl = appendParams(requestUtl, key, params[key], true)
          } else {
            requestUtl = appendParams(requestUtl, key, params[key], false)
          }
        }
      }
      return requestUtl
    } else {
      return baseUrl
    }
  }

  static getCouponSharePathUrl(domainUrl, params) {
    let detailsPath = AppRouteConfig.getCouponSharePath()
    let pathUrl = RouterSwitchHelper.getTargetUrl(domainUrl + detailsPath, params)
    return pathUrl
  }

  static getRedPacketPathUrl(domainUrl, params) {
    let detailsPath = AppRouteConfig.getRedPacketPath()
    let pathUrl = RouterSwitchHelper.getTargetUrl(domainUrl + detailsPath, params)
    return pathUrl
  }

  static getSalesTaskPathUrl(domainUrl, params) {
    let detailsPath = AppRouteConfig.getSalesTaskPath()
    let pathUrl = RouterSwitchHelper.getTargetUrl(domainUrl + detailsPath, params)
    return pathUrl
  }

  static getMemberCardBuyPathUrl(domainUrl, params) {
    let detailsPath = AppRouteConfig.getMemberCardBuyPath()
    let pathUrl = RouterSwitchHelper.getTargetUrl(domainUrl + detailsPath, params)
    return pathUrl
  }

  static getProductSpecialPathUrl(domainUrl, params) {
    let detailsPath = AppRouteConfig.getProductSpecialPath()
    let pathUrl = RouterSwitchHelper.getTargetUrl(domainUrl + detailsPath, params)
    return pathUrl
  }
}